import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

// Helpers
import { capitalize } from "@/_helpers/text_functions";

// Services and interfaces
import { ICoach } from "@/interfaces/coach/coach";

// Components
import { Box } from "@mui/material";
import CoachMenu from "./coach_menu";
import Avatar from "@/components/avatar";
import { ColDef } from "@/components/datatable";


const useCoachTableHeaders = (): ColDef<ICoach>[] => {

    const { t } = useTranslation();

    const headers: ColDef<ICoach>[] = [
        {
            field: 'full_name',
            headerName: t('components.dataTable.headers.name'),
            width: '20%',
            sortable: true,
            render: (row, i) => <Box display="flex" alignItems="center">
                <Avatar index={i} name={row.full_name} src={row.avatar ?? ''} />
                <Box ml="12px">
                    {capitalize(row.full_name)}
                </Box>
            </Box>
        },
        {
            field: 'email',
            headerName: t('components.dataTable.headers.email'),
            width: '25%',
            sortable: true,
            render: (row) => <span className="OneLine--ellipsis-breakWord">{row.email}</span>
        },
        {
            field: 'user_id',
            headerName: t('components.dataTable.headers.userId'),
            render: (row) => row.user_meta.id ?? '-'
        },
        {
            field: 'coachId',
            headerName: t('components.dataTable.headers.coachId'),
            render: (row) => row.id ?? '-'
        },
        {
            field: 'timezone',
            headerName: t('components.dataTable.headers.timezone'),
            render: (row) => row.user_meta.timezone ?? '-'
        },
        {
            field: 'created_at',
            headerName: t('components.dataTable.headers.created'),
            render: (row) => row.user_meta.created_at ? dayjs(row.user_meta.created_at).format('DD/MM/YYYY') : '-'
        },
        {
            field: 'actions',
            headerName: '',
            width: '6%',
            render: (row: ICoach) => <CoachMenu row={row} />
        }
    ]

    return headers;
}

export default useCoachTableHeaders;